import React from 'react';
import { PrimaryButton } from '@fluentui/react';
import './styles.scss';

const LoadingButton = (props) => {
  const { text, onClick = () => { console.log('Function Called') }, showProgress = false } = props
  return (
    <PrimaryButton
      className={`loading-btn loading-btn-${showProgress}`}
      text={text}
      onClick={onClick}
    />
  );
}

export default LoadingButton;